import React, { useContext } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { Header as HeaderSuite, Nav } from 'rsuite'
import menuItems from 'config/MenuItems'
import { AuthContext } from 'contexts/AuthContext'
import { FaSignOutAlt, FaUser, FaWallet } from 'react-icons/fa'
import logo from '../../../assets/images/agrobeet-logo.png'
import './header.scss'

const Header: React.FC = () => {
  const location = useLocation()
  const authContext = useContext(AuthContext)
  const displayName = authContext?.user?.displayName || 'User'
  const { id } = useParams()

  const currentMenuItem = menuItems.find(
    (item) =>
      item.link === location.pathname ||
      item.subMenu?.some((subItem) => subItem.link === location.pathname)
  )
  let name = 'Dashboard'

  if (location.pathname === '/channels/WhatsApp') {
    name = 'WhatsApp'
  } else if (location.pathname === '/channels/AgroBeet-App') {
    name = 'App'
  } else if (location.pathname === '/channels/SMS') {
    name = 'SMS'
  } else if (location.pathname === '/wallet/transaction') {
    name = 'Transaction History'
  } else if (location.pathname === '/wallet') {
    name = 'Wallet'
  } else if (location.pathname === `/document-verification/company/${id}`) {
    name = 'Documents'
  } else {
    name =
      currentMenuItem?.subMenu?.find(
        (subItem) => subItem.link === location.pathname
      )?.name ||
      currentMenuItem?.name ||
      'Dashboard'
  }

  return (
    <HeaderSuite className="header">
      <img src={logo} className="header__logo" alt="Agrobeet-App-Admin" />
      <Nav className="header__dashboard-link">
        <span className="header__dashboard-link__text">{name}</span>
      </Nav>

      <Nav className="header__user">
        <Nav.Menu title={<span>{displayName}</span>}>
          <Nav.Item as={Link} to="/profile" icon={<FaUser />}>
            Profile
          </Nav.Item>
          <Nav.Item as={Link} to="/wallet" icon={<FaWallet />}>
            Wallet
          </Nav.Item>
          <Nav.Item as={Link} to="/logout" icon={<FaSignOutAlt />}>
            Logout
          </Nav.Item>
        </Nav.Menu>
      </Nav>
    </HeaderSuite>
  )
}

export default Header
